/*
  Hot Diamonds: odhad doruceni ("Pozitri u vas"), jeden skript pro cely web.
  Shopify: assets/hd-delivery-date.js, nacita se v layout/theme.liquid (defer).

  Plni dva druhy mist:
  - karty produktu: prazdny <p data-hd-delivery-card hidden> ze snippets/hd-stock-label.liquid
  - detail produktu a rychly nahled ("Vybrat moznosti"): <p data-hd-delivery-date hidden>
    ze snippets/hd-delivery-date.liquid, vedle nej JSON se skladem po variantach.
    Ukaze se jen u vybrane varianty, ktera je realne skladem, a hlida zmenu varianty.

  Nastaveni (jen tady, plati pro cely web):
  - HD_CUTOFF: uzaverka pro odeslani tyz den (prazsky cas), SLA XCW: 30 min pred svozem
  - HD_TRANSIT: pracovni dny od predani dopravci po doruceni
  - HD_DELIVERY_ON: vypinac, false = radek se nikde neukaze
*/
(function () {
  var HD_DELIVERY_ON = true;
  var HD_CUTOFF = '13:00';
  var HD_TRANSIT = 1;

  if (!HD_DELIVERY_ON) return;

  // Velikonoce (gregoriansky algoritmus), kvuli Velkemu patku a Velikonocnimu pondeli
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }

  var DAY = 86400000;
  var FIXED = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'];

  function isWorkday(t) {
    var d = new Date(t);
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    if (FIXED.indexOf(d.getUTCMonth() + 1 + '-' + d.getUTCDate()) !== -1) return false;
    var e = easter(d.getUTCFullYear());
    return t !== e - 2 * DAY && t !== e + DAY;
  }

  function nextWorkday(t) {
    do { t += DAY; } while (!isWorkday(t));
    return t;
  }

  // Dnesni datum a cas v Praze bez ohledu na casove pasmo zakaznika
  function pragueNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Prague', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = +p.value; });
    return parts;
  }

  function deliveryText(now) {
    var today = Date.UTC(now.year, now.month - 1, now.day);
    var cut = HD_CUTOFF.split(':');
    var beforeCutoff = now.hour * 60 + now.minute < +cut[0] * 60 + +cut[1];
    var t = isWorkday(today) && beforeCutoff ? today : nextWorkday(today);
    for (var i = 0; i < HD_TRANSIT; i++) t = nextWorkday(t);

    var diff = Math.round((t - today) / DAY);
    if (diff === 1) return 'Zítra u vás';
    if (diff === 2) return 'Pozítří u vás';
    var d = new Date(t);
    var days = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
    return 'U vás ' + days[d.getUTCDay()] + ' ' + d.getUTCDate() + '. ' + (d.getUTCMonth() + 1) + '.';
  }

  // Na strance je vic vyberu varianty (doporucene produkty, kosik, rychly nahled),
  // bereme ten s variantou tohoto produktu, nejdriv ve stejne sekci
  function findInput(el, stock) {
    var scopes = [el.closest('.quick-product, [data-section-type="product"]'), document];
    for (var s = 0; s < scopes.length; s++) {
      if (!scopes[s]) continue;
      var inputs = scopes[s].querySelectorAll('[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        if (stock.hasOwnProperty(inputs[i].value)) return inputs[i];
      }
    }
    return null;
  }

  function updateProduct(el, text) {
    if (!el._hdStock) {
      var stockEl = el.parentNode.querySelector('[data-hd-delivery-stock]');
      if (!stockEl) return;
      el._hdStock = JSON.parse(stockEl.textContent);
    }
    var input = findInput(el, el._hdStock);
    var show = !!(input && el._hdStock[input.value]);
    // Menit jen kdyz je co, jinak by se observer zacyklil
    if (show && el.textContent !== text) el.textContent = text;
    if (el.hidden === show) el.hidden = !show;
  }

  function refresh() {
    var text = deliveryText(pragueNow());

    var cards = document.querySelectorAll('[data-hd-delivery-card][hidden]');
    for (var i = 0; i < cards.length; i++) {
      cards[i].textContent = text;
      cards[i].hidden = false;
    }

    var products = document.querySelectorAll('[data-hd-delivery-date]');
    for (var j = 0; j < products.length; j++) updateProduct(products[j], text);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      refresh();
    }, 50);
  }

  // Karty i rychly nahled se dohravaji pozdeji a tema prepisuje dostupnost pri zmene varianty,
  // proto hlidame zmeny na strance a zmeny ve formularich
  function start() {
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();